enum DateOptions {
  Today = "Today",
  Yesterday = "Yesterday",
  LastSevenDays = "LastSevenDays",
  LastThirtyDays = "LastThirtyDays",
  LastSixMonths = "LastSixMonths",
  LastOneYear = "LastOneYear",
  Custom = "Custom"
}

export default DateOptions;
